import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ResumeModalProps {
    visible: boolean;
    onClose: () => void;
}

const ResumeModal: React.FC<ResumeModalProps> = ({ visible, onClose }) => {
    return (
        <AnimatePresence>
            {visible && (
                <div style={styles.backdrop}>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        transition={{ duration: 0.3, ease: 'easeOut' }}
                        style={styles.modal}
                        className="resume-modal-container"
                    >
                        {/* Title Bar */}
                        <div style={styles.titleBar}>
                            <p style={styles.titleText}>RESUME_VIEWER.EXE</p>
                            <button 
                                onClick={onClose} 
                                style={styles.closeButton}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#ff5f56';
                                    e.currentTarget.style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                    e.currentTarget.style.color = '#fff';
                                }}
                            >
                                X
                            </button>
                        </div>

                        {/* Content */}
                        <div style={styles.content}>
                            <div style={styles.header}>
                                <h2 style={styles.name}>DENNIS NZIOKI</h2>
                                <p style={styles.role}>Software Engineer & UI/UX Designer</p>
                                <p style={styles.location}>Nairobi, Kenya</p>
                            </div>

                            <hr style={styles.divider} />

                            <div style={styles.actions}>
                                <a 
                                    href="/resume.pdf" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    style={styles.actionBtn}
                                >
                                    [1] VIEW RESUME (PDF)
                                </a>
                                <a 
                                    href="/resume.pdf" 
                                    download="Dennis_Nzioki_Resume.pdf" 
                                    style={styles.actionBtn}
                                >
                                    [2] DOWNLOAD RESUME
                                </a>
                                <a 
                                    href="mailto:contact@dennisnzioki.com" 
                                    style={styles.actionBtn}
                                >
                                    [3] SEND EMAIL
                                </a>
                                <a 
                                    href="https://linkedin.com/in/dennisnzioki" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    style={styles.actionBtn}
                                >
                                    [4] LINKEDIN PROFILE
                                </a>
                            </div>

                            <div style={styles.footerInfo}>
                                <p style={styles.footerText}>Strathmore University Graduate · Business Information Technology</p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    backdrop: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 999999,
        pointerEvents: 'auto'
    },
    modal: {
        width: '90%',
        maxWidth: '500px',
        backgroundColor: 'rgba(10, 15, 10, 0.95)',
        border: '3px solid #00ff00',
        boxShadow: '0 0 20px rgba(0, 255, 0, 0.3)',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
    },
    titleBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '2px solid #00ff00',
        padding: '8px 16px',
        backgroundColor: 'rgba(0, 255, 0, 0.1)',
    },
    titleText: {
        margin: 0,
        fontWeight: 'bold',
        color: '#00ff00',
        letterSpacing: '1px',
    },
    closeButton: {
        background: 'transparent',
        border: '1px solid #00ff00',
        color: '#00ff00',
        cursor: 'pointer',
        padding: '2px 8px',
        fontSize: '14px',
        fontFamily: 'monospace',
        transition: 'all 0.2s',
    },
    content: {
        padding: '30px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    header: {
        textAlign: 'center',
        marginBottom: '20px',
    },
    name: {
        margin: '0 0 5px 0',
        fontSize: '24px',
        letterSpacing: '2px',
        color: '#00ff00',
    },
    role: {
        margin: '0 0 5px 0',
        color: '#ccc',
        fontSize: '14px',
    },
    location: {
        margin: 0,
        color: '#888',
        fontSize: '12px',
    },
    divider: {
        width: '100%',
        border: 'none',
        borderTop: '1px solid #333',
        margin: '0 0 20px 0',
    },
    actions: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    actionBtn: {
        display: 'block',
        textAlign: 'left',
        border: '1px solid #00ff00',
        color: '#00ff00',
        padding: '12px 16px',
        fontSize: '14px',
        textDecoration: 'none',
        transition: 'all 0.2s',
        backgroundColor: 'rgba(0, 255, 0, 0.05)',
        fontFamily: 'monospace',
        cursor: 'pointer',
    },
    footerInfo: {
        marginTop: '30px',
        textAlign: 'center',
    },
    footerText: {
        fontSize: '11px',
        color: '#666',
        margin: 0,
    }
};

export default ResumeModal;
